jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
	passwordRestrictionBox: {
		conf: {
			boxName: '',
			emailNoticeInputs: '',
			passwordInputId: '',
		},

		init: function init() {
			const passwordRestrictionInputs = 'input.checkPassword';
			this.conf.boxName = '#wdk-passwordRestrictionBox';
			this.conf.emailNoticeInputs = '#regFormEmail';
			// IE8 nutzt das Placeholder-Plugin. Dieses erzeugt für die Default-Texte Text-Inputs. Diese fallen sonst auch in diesen Selektor mit rein!
			this.conf.passwordInputId = '#' + $j(passwordRestrictionInputs + '[type=password]:first').attr('id');

			const _this = this;
			if ($j(this.conf.boxName).data('showAlways') === false) {
				$j(passwordRestrictionInputs + '[type=password]').on('focus', function () {
					_this.showRestrictionBox();
				});

				$j(passwordRestrictionInputs + '[type=password]').on('blur', function () {
					_this.hideRestrictionBox();
				});
			}

			$j(passwordRestrictionInputs).on('keyup change', function () {
				_this.checkPasswordRestrictions();
			});
		},

		showRestrictionBox: function showRestrictionBox() {
			this.checkPasswordRestrictions();
			$j(this.conf.boxName).fadeIn(400);
		},

		hideRestrictionBox: function hideRestrictionBox() {
			$j(this.conf.boxName).fadeOut(400);
		},

		checkPasswordRestrictions: function checkPasswordRestrictions() {
			this.checkLength();
			this.checkLettersAndNumbers();

			if ($j('#partOfEmail').length) {
				this.checkPartOfEmail();
			}

			if ($j(this.conf.boxName + ' ul li').length === $j(this.conf.boxName + ' ul li.success').length) {
				$j(this.conf.boxName).addClass('success');
			} else {
				$j(this.conf.boxName).removeClass('success');
			}
		},

		checkLength: function checkLength() {
			if ($j(this.conf.passwordInputId).val().length >= 8) {
				this.setRestrictionToSuccess('#minCharacters');
			} else {
				this.setRestrictionToError('#minCharacters');
			}
		},

		checkLettersAndNumbers: function checkLettersAndNumbers() {
			const password = $j(this.conf.passwordInputId).val();
			const hasCharacter = /.*[a-zA-Z]+.*/g.test(password);
			const hasNumber = /.*[0-9]+.*/g.test(password);
			const hasSpecialCharacter = /.*[^a-zA-Z0-9\s]+.*/g.test(password);

			if ((hasCharacter && hasNumber) || (hasCharacter && hasSpecialCharacter)) {
				this.setRestrictionToSuccess('#lettersAndNumbers');
			} else {
				this.setRestrictionToError('#lettersAndNumbers');
			}
		},

		checkPartOfEmail: function checkPartOfEmail() {
			const frontEmailPart = $j(this.conf.emailNoticeInputs).val().split('@')[0];
			const passwordFilled = $j(this.conf.passwordInputId).val().length > 0;
			const passwordIsNotPartOfEmail = $j(this.conf.passwordInputId).val().indexOf(frontEmailPart) < 0;

			if (passwordFilled && (frontEmailPart === '' || passwordIsNotPartOfEmail)) {
				this.setRestrictionToSuccess('#partOfEmail');
			} else {
				this.setRestrictionToError('#partOfEmail');
			}
		},

		setRestrictionToSuccess: function setRestrictionToSuccess(element) {
			$j(element).removeClass('error');
			$j(element).addClass('success');
		},

		setRestrictionToError: function setRestrictionToError(element) {
			$j(element).removeClass('success');
			$j(element).addClass('error');
		},

		isPasswordValid: function isPasswordValid() {
			return $j(this.conf.boxName + ' ul li').length === $j(this.conf.boxName + ' ul li.success').length;
		},
	},
});
